module.exports = __webpack_public_path__ + "img/9788936456474.38a2e30c.jpg";